{
    "warning": "WARNUNG!",
    "message": "Gib oder füge keinen Code ein, den du nicht verstehst.\nDiese Konsole ermöglicht es Angreifern, sich als du auszugeben und deine Daten mithilfe eines Angriffs namens Self-XSS zu stehlen."
}
